import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import PyovsPyo from './PyovsPyo.';
import Admin from './views/Admin';
import AdminLogin from './views/AdminLogin';

class App extends React.Component {

  render() {
    return (
      <>
        <BrowserRouter>
          <Switch>
            <Route exact path='/admin/login' component={AdminLogin}/>
            <Route path='/admin' component={Admin}/>
            <Route path="/" component={PyovsPyo}/>
          </Switch>
        </BrowserRouter>
        <div className="drag-target"></div>
      </>
    );
  }

}

export default App;
